/** Gedeeld contract. Bevoegdheden en writes zitten in api/_lib/klachten. */
export const KLACHT_STAPPEN = ['beoordeling', 'aanbod', 'wacht_klant', 'klaar_voor_behandeling', 'vrijgave', 'behandeling', 'controle', 'afronden', 'afgerond', 'geannuleerd'] as const;
export type KlachtStap = typeof KLACHT_STAPPEN[number];
export const KLACHT_STAP_LABEL: Record<KlachtStap, string> = {
  beoordeling: 'Beoordeling wasserij', aanbod: 'Aanbod maken', wacht_klant: 'Wacht op klantkeuze',
  klaar_voor_behandeling: 'Behandeling vrijgeven', behandeling: 'In behandeling',
  vrijgave: 'Vrijgave controleren',
  controle: 'Resultaat controleren', afronden: 'Afronden en pauze vrijgeven',
  afgerond: 'Afgerond', geannuleerd: 'Geannuleerd',
};
export interface KlachtBeoordeling {
  uitkomst: 'behandelen' | 'niet_behandelen';
  behandeling: string;
  verwachting: string;
  risicos: string[];
  toelichting: string;
  door: string;
  at: string;
}
export interface KlachtBehandeling {
  id: string;
  klacht_id: string;
  wo_sf_id: string;
  wi_sf_id: string;
  wi_naam: string;
  stap: KlachtStap;
  versie: number;
  vraag: string;
  eigenaar: string;
  verwacht_op: string;
  beoordeling: KlachtBeoordeling | null;
  aanbod: { bericht_id: string; beoordeling_versie: number; tekst: string; at: string } | null;
  keuze: { bericht_id: string; keuze: 'behandelen' | 'zo_laten'; citaat: string; door: string; at: string } | null;
  resultaat: { notitie: string; door: string; at: string } | null;
  source_message_id: string | null;
  created_at: string;
  updated_at: string;
}
export interface KlachtBron {
  bron: string;
  status: 'geladen' | 'leeg' | 'onbeschikbaar' | 'beperkt';
  aantal: number;
  toelichting?: string;
}
export interface KlachtPlan {
  generatie_id: string;
  beleid: 'klachtketen-2026-09-08';
  oplossing: string;
  nodig: string[];
  order_referentie: string | null;
  item_referentie: string | null;
  behandeling_id: string | null;
  beoordeling_versie: number | null;
  stap: 'beoordeling' | 'aanbod' | 'keuze' | 'uitvoering' | 'controle' | 'afronding' | 'antwoord';
  bronnen: KlachtBron[];
}

export function normaliseerBewijs(tekst: string): string {
  return tekst.normalize('NFKC').replace(/\s+/g, ' ').trim().toLocaleLowerCase('nl-NL');
}

/** Kritieke onderdelen moeten werkelijk in het verzonden antwoord staan. */
export function bevatKlachtaanbod(tekst: string, beoordeling: KlachtBeoordeling): boolean {
  if (beoordeling.uitkomst !== 'behandelen') return false;
  const delen = [beoordeling.behandeling, beoordeling.verwachting, ...beoordeling.risicos];
  const bron = normaliseerBewijs(tekst);
  return delen.length >= 2 && delen.every(d => d.trim().length >= 3 && bron.includes(normaliseerBewijs(d)));
}

/** Geen semantische akkoordherkenning als autorisatie. Een mens beoordeelt het citaat. */
export function geldigKeuzeCitaat(bericht: string, citaat: string): boolean {
  const quote = normaliseerBewijs(citaat);
  return quote.length >= 5 && quote.length <= 1000 && normaliseerBewijs(bericht).includes(quote);
}

export function openKlachtStap(stap: string): boolean {
  return stap !== 'afgerond' && stap !== 'geannuleerd';
}
